var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQbMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.09 18.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2ca01c",
    d: "m9.04,18.09c4.99,0,9.04-4.05,9.04-9.04S14.04,0,9.04,0,0,4.05,0,9.04s4.05,9.04,9.04,9.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2.53,9.04c0,1.91,1.56,3.44,3.5,3.44h.5v-1.28h-.5c-1.2,0-2.2-.98-2.2-2.16s1-2.16,2.2-2.16h1.2v6.68c0,.69.6,1.28,1.3,1.28V5.6h-2.51c-1.95,0-3.5,1.52-3.5,3.44h0Zm9.52-3.44h-.5v1.28h.5c1.2,0,2.2.98,2.2,2.16s-1,2.16-2.2,2.16h-1.2v-6.68c0-.69-.6-1.28-1.3-1.28v9.24h2.51c1.95,0,3.5-1.52,3.5-3.44s-1.56-3.44-3.5-3.44h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQbMark);
export default __webpack_public_path__ + "static/media/qb-mark.1e72c5be20cdabdbef5465a8ee84c74e.svg";
export { ForwardRef as ReactComponent };